import { BallBg, Clickable, Icon, NewsBox, Row, Text } from 'components';
import { Api, theme } from 'lib';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Loading } from '../components';

const PurpleArea = styled.div`
  height: 804px;
  margin-top: 100px;
  width: 100%;
  background-color: ${theme.DARK_PURPLE};
  margin-bottom: -907px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const MobilePurpleArea = styled.div`
  height: 258px;
  margin-top: 100px;
  width: 100%;
  background-color: ${theme.DARK_PURPLE};
  margin-top: -189px;
`;

const MobileFourNews = styled.div`
  width: 100vw;
  margin: 26px 0 0;

  @media (min-width: 1024px) {
    display: none;
  }
`;

const FourNews = styled.div`
  @media (max-width: 1024px) {
    display: none;
  }
`;

const ContentArea = styled.div`
  width: 1140px;
  align-self: center;
  display: flex;
  flex-wrap: wrap;
  margin: ${(props) => (props.marg ? props.marg : '0')};

  @media (max-width: 1024px) {
    width: 100vw;
    margin-top:;
  }
`;

const ScrollNewsBox = styled(NewsBox)`
  margin: 50px;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  align-self: center;
  flex-direction: column;

  .header-text {
    margin: 17px 0 11px;
    font-weight: 500;
    font-size: 20px;
  }

  .main-header-text {
    margin: 17px 0 11px;
    font-weight: 500;
    font-size: 20px;
  }

  .header-text-changing {
    margin: 17px 0 11px;
    font-weight: 500;
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    width: 100vw;

    .header-text {
      margin: 22px 17px 10px;
      font-weight: 500;
      font-size: 16px;
    }

    .main-header-text {
      display: none;
    }

    .header-text-changing {
      margin: 10px 17px 10px;
      font-weight: 500;
      font-size: 16px;
      color: black;
    }
  }
`;

const Arrows = styled.div`
  display: flex;
  bottom: 10px;
  margin: 40px 0 0;
  padding: 0 0 7px 0;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const BackgroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
  overflow-y: hidden;

  .scroll {
    overflow-x: ${navigator.platform !== 'Win32' ? 'scroll;' : 'hidden;'} @media (max-width: 1024px) {
      overflow-x: scroll;
    }
  }
`;

const ScrollNewsContainer = styled.div`
  display: flex;
  flex-direction: row;

  scroll-behavior: smooth;

  @media (max-width: 1024px) {
    padding: 0 13px;
  }
`;

const NewsContainer = styled.div`
  width: 1140px;
  align-self: center;
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    width: 100vw;
    flex-wrap: unset;
    flex-direction: column;
  }
`;

const BoxContainer = styled.div`
  margin: ${(props) => (props.idx % 4 !== 0 ? '0 0 32px 32px' : '0 0 32px')};

  @media (max-width: 1024px) {
    margin: 0;
  }
`;

const News = (props) => {
  const { t } = useTranslation();
  const [news, setNews] = useState(null),
    navigate = useNavigate(),
    [extraPad, setExtraPad] = useState('0px'),
    newsRef = useRef(null),
    shouldRenderTop = news?.length >= 5;

  function handleScroll(direction) {
    const el = document.getElementById('newsScroll');
    const scrollPos = el.scrollLeft;

    el.scroll({
      left: direction === 'left' ? (scrollPos - 700 < 700 ? 0 : scrollPos - 700) : scrollPos + 700,
      behavior: 'smooth'
    });
  }

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  useEffect(() => {
    handleExtraPad();
    fetchNews();

    setInterval(() => {
      fetchNews();
    }, 30000);
  }, []);

  async function fetchNews() {
    const res = await Api.get('/website/fetchNews');
    if (!res) return;

    setNews(res.news);
  }

  return (
    <React.Fragment>
      <Loading isLoading={!news} />
      <BallBg />

      {news && (
        <Container>
          {shouldRenderTop && <PurpleArea />}

          <ContentArea marg="20px 0 0">
            {shouldRenderTop && (
              <React.Fragment>
                <Text className="main-header-text">{t('website.news')}</Text>
                <Row start>
                  <NewsBox item={news[0]} large dontShowDate />

                  <FourNews>
                    <Row>
                      <NewsBox item={news[1]} big dontShowDate />
                      <NewsBox item={news[2]} big dontShowDate />
                    </Row>
                    <Row>
                      <NewsBox item={news[3]} big dontShowDate />
                      <NewsBox item={news[4]} big dontShowDate />
                    </Row>
                  </FourNews>
                </Row>

                <MobileFourNews>
                  <BackgroundContainer>
                    <div
                      id="fourNewsScroll"
                      style={{ paddingLeft: extraPad, overflowX: 'scroll', overflowY: 'hidden' }}
                      ref={newsRef}
                    >
                      <ScrollNewsContainer>
                        {[news[1], news[2], news[3], news[4]].map((x, i) => (
                          <ScrollNewsBox
                            key={i}
                            item={x}
                            size="285px"
                            dontShowDate
                            big
                            marg="0 50px 0 0"
                          />
                        ))}
                      </ScrollNewsContainer>
                    </div>
                  </BackgroundContainer>
                  <MobilePurpleArea />
                </MobileFourNews>
              </React.Fragment>
            )}

            <Row center between wid="100%" marg="10px 0 0">
              <Text col={shouldRenderTop ? '#fff' : '#000'} className="header-text-changing">
                {t('website.highlights')}
              </Text>

              <Arrows>
                <Clickable marg="0 16px 0 0" onClick={() => handleScroll('left')}>
                  <Icon
                    col={shouldRenderTop ? '#fff' : '#000'}
                    type="arrowLeftLong"
                    dimensions={25}
                  />
                </Clickable>

                <Clickable onClick={() => handleScroll('right')}>
                  <Icon
                    col={shouldRenderTop ? '#fff' : '#000'}
                    type="arrowRightLong"
                    dimensions={25}
                  />
                </Clickable>
              </Arrows>
            </Row>
          </ContentArea>

          <BackgroundContainer>
            <div
              id="newsScroll"
              className="scroll"
              style={{ paddingLeft: extraPad, overflowY: 'hidden' }}
              ref={newsRef}
            >
              <ScrollNewsContainer>
                {news.map((x, i) => (
                  <ScrollNewsBox key={i} item={x} size="285px" dontShowDate marg="0 50px 0 0" />
                ))}
              </ScrollNewsContainer>
            </div>
          </BackgroundContainer>

          <ContentArea marg="37px 0 0">
            <Text className="header-text">{t('website.recentArticles')}</Text>

            <NewsContainer>
              {news?.map((x, i) => (
                <BoxContainer idx={i}>
                  <NewsBox marg="0 0 10px" item={x} i={i} key={i} mobileImageless />
                </BoxContainer>
              ))}
            </NewsContainer>
          </ContentArea>
        </Container>
      )}
    </React.Fragment>
  );
};

export default News;
